<div class="d-flex justify-content-center ag-bg-black" style="min-height: 100vh;">
  <div class="col-12 col-md-5 col-lg-4 mx-auto align-self-center py-4">

    <div class="p-3 text-center">
      <img src="assets/images/logo-horizontal-blanc@4x.png" class="img-fluid" alt="AGODJIE" style="height: 60px;">
    </div>

    <div class="card shadow">
      <div class="card-body p-4">

        <div class="text-center mb-3">
          <h5 class="mb-1">Activation de votre compte</h5>
          <p class="text-muted small mb-0">
            Il s'agit de votre première connexion. Choisissez un mot de passe
            personnel pour activer votre accès.
          </p>
        </div>

        <form #fpForm="ngForm" (ngSubmit)="changeFirstPassword(fpForm.value)" novalidate>

          <div class="position-relative form-group mb-3">
            <label for="password" class="form-label">Nouveau mot de passe</label>
            <div class="input-group">
              <input [type]="showPassword ? 'text' : 'password'"
                     name="password" id="password"
                     placeholder="Au moins 8 caractères"
                     minlength="8" class="form-control"
                     [(ngModel)]="password" #pwd="ngModel" required>
              <button class="btn btn-outline-secondary" type="button"
                      (click)="showPassword = !showPassword"
                      [attr.aria-label]="showPassword ? 'Masquer' : 'Afficher'">
                <i class="fa" [class.fa-eye]="!showPassword" [class.fa-eye-slash]="showPassword" aria-hidden="true"></i>
              </button>
            </div>
            <div class="form-text" [class.text-danger]="pwd.touched && !isLongEnough()">
              8 caractères minimum.
            </div>
          </div>

          <div class="position-relative form-group mb-3">
            <label for="confirm_password" class="form-label">Confirmer le mot de passe</label>
            <input [type]="showPassword ? 'text' : 'password'"
                   name="confirm_password" id="confirm_password"
                   placeholder="Ressaisissez le mot de passe"
                   minlength="8" class="form-control"
                   [(ngModel)]="confirmPassword" #cpwd="ngModel" required>
            <div class="form-text text-danger" *ngIf="cpwd.touched && confirmPassword && !passwordsMatch()">
              Les deux mots de passe ne sont pas identiques.
            </div>
            <div class="form-text text-success" *ngIf="confirmPassword && passwordsMatch() && isLongEnough()">
              <i class="fa fa-check me-1" aria-hidden="true"></i>Les mots de passe correspondent.
            </div>
          </div>

          <div class="mt-4 d-grid">
            <button class="btn btn-primary btn-lg" type="submit" [disabled]="!canSubmit()">
              Activer mon compte
              <app-loading [isVisible]="loading"></app-loading>
            </button>
          </div>

          <p class="text-muted small text-center mt-3 mb-0">
            Vous serez déconnecté puis invité à vous reconnecter avec ce nouveau mot de passe.
          </p>

        </form>
      </div>
    </div>
  </div>
</div>
